import React from 'react';
import { MdCheckBoxOutlineBlank } from 'react-icons/md';
import { IoMdCheckbox } from 'react-icons/io';

const FormRadio = ({ title, change, radioValue, selectedPayment, farm, click }) => {
  return (
    <div className="pr-3 md:pr-6">
      {farm ? (
        <label onClick={click} className="flex items-center">
          <input
            type="radio"
            className="hidden"
            name="farmRadio"
            onChange={change}
            value={radioValue}
          />
          <span>
            {selectedPayment === radioValue ? (
              <IoMdCheckbox className="text-xl text-cf-dark" />
            ) : (
              <MdCheckBoxOutlineBlank className="text-base md:text-xl" />
            )}
          </span>
          <span className="ml-2 text-xs md:text-sm">{title}</span>
        </label>
      ) : (
        <label onClick={click} className="inline-flex items-center">
          <span className="text-xs md:text-sm mr-3">{title}</span>
          <input
            type="radio"
            className="form-radio text-cf-300"
            name="farmRadio"
            onChange={change}
            value={radioValue}
          />
        </label>
      )}
    </div>
  );
};

export default FormRadio;
